import { structureOperation } from './request';
export default {
  data() {
    return {
      currentRow: null,
      dialogVisible: false,
      loading: false,
      customerId: '',
      roleFrom: {
        name: '',
        parentId: '',
        customerId: ''
      },
      type: ''
    };
  },
  computed: {
    roleRule() {
      return {
        name: [{
          required: true,
          trigger: 'blur',
          message: this.$t('请至少输入名称')
        }]
      };
    }
  },
  methods: {
    init(customerId, data, type) {
      console.log(customerId, data, type);
      this.roleFrom.customerId = customerId;
      this.roleFrom.parentId = data ? data.parentId : 0;
      if (!type) {
        this.roleFrom.name = data.name;
      } else {
        this.roleFrom.parentId = data ? data.id : 0;
      }
      this.currentRow = data;
      this.type = type;
      this.dialogVisible = true;
    },
    handleSure() {
      console.log(55);
      this.$refs.roleFrom.validate(valid => {
        this.loading = true;
        if (valid) {
          if (this.currentRow && this.currentRow.id && !this.type) {
            this.roleFrom.structureId = this.currentRow.id;
          }
          structureOperation(this.roleFrom).then(res => {
            this.$message.success(this.$t('操作成功') + '!');
            this.loading = false;
            this.$emit('ok');
            this.$emit('cancel');
          });
        }
      });
    }
  }
};